// extracted by mini-css-extract-plugin
export var typingIndicator = "_se-0";